import React from 'react';
import { Redirect } from 'react-router';
import { useAuth } from './auth';

const GuestRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { loggedIn } = useAuth();

  if (loggedIn) {
    return <Redirect to="/my/training" />;
  }

  return children;
};

export default GuestRoute;
